'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import * as CustomRenderer from 'UIComponents/utils/propTypes/customRenderer';
import Review from 'marketplace-ui-reviews/records/Review';
import LegacyReview from '../../../records/Review';
import DefaultReviewRenderer from '../renderers';
/** @deprecated use BaseReviewModal.tsx in marketplace-ui-reviews once your app is using the records from marketplace-ui-reviews */

const BaseReviewModal = (_ref) => {
  let {
    review,
    ReviewRenderer,
    title,
    form,
    onConfirm,
    onClose,
    confirmButtonText,
    confirmButtonDataId,
    cancelButtonText,
    confirmDisabled,
    tooltip,
    width,
    catalogServices
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["review", "ReviewRenderer", "title", "form", "onConfirm", "onClose", "confirmButtonText", "confirmButtonDataId", "cancelButtonText", "confirmDisabled", "tooltip", "width", "catalogServices"]);

  return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
    width: width,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: title
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [form, /*#__PURE__*/_jsx(ReviewRenderer, {
        catalogServices: catalogServices,
        review: review
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !confirmDisabled || !tooltip,
        title: tooltip,
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": confirmButtonDataId,
          use: "primary",
          disabled: confirmDisabled,
          onClick: onConfirm,
          children: confirmButtonText
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onClose,
        children: cancelButtonText
      })]
    })]
  }));
};

BaseReviewModal.propTypes = {
  review: PropTypes.oneOfType([PropTypes.instanceOf(LegacyReview), PropTypes.instanceOf(Review)]),
  ReviewRenderer: CustomRenderer.propType,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  form: CustomRenderer.propType,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.node,
  confirmButtonDataId: PropTypes.string,
  cancelButtonText: PropTypes.node,
  confirmDisabled: PropTypes.bool,
  tooltip: PropTypes.node,
  width: PropTypes.number,
  catalogServices: PropTypes.array
};
BaseReviewModal.defaultProps = {
  ReviewRenderer: DefaultReviewRenderer,
  confirmButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ecosystemMarketplaceCore.reviews.modal.confirm"
  }),
  cancelButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ecosystemMarketplaceCore.reviews.modal.cancel"
  }),
  confirmDisabled: false,
  width: 800
};
export default BaseReviewModal;